import styled from 'styled-components';

export const ListMiniCardsStyles = styled.div`
  .card-enter {
    opacity: 0;
  }

  .card-enter-active {
    opacity: 1;
    transition: all 200ms cubic-bezier(0.46, 1.05, 0.44, 0.63);
  }

  .card-exit {
    opacity: 1;
    max-height: 150px; // TODO maybe replace om translate
  }

  .card-exit-active {
    opacity: 0;
    height: auto;
    max-height: 0;
    transition: max-height 300ms ease-in-out, opacity 300ms ease-in-out;
  }
`;
